export default {
  allReceivables: (state) => state.receivables,
  receivableLoadingStatus: (state) => state.receivableLoadingStatus
}
